const routes = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M12.34 3.66 9.49 10.9l-1.1-2.8-.25-.63-.64-.23-2.23-.8zM15 1 1 6.51l6 2.14L9.49 15z"/></svg>',
};

export { routes as default };
